module.exports = __webpack_public_path__ + "img/sfqh-currency-guide-1.c27715a4.png";